import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

type EstaEnLiquidacionProformaResponse = {
  value: boolean;
};

type EstaEnLiquidacionProformaParams = {
  oidVisita: number;
};

export const estaEnLiquidacionProforma = async (
  query: EstaEnLiquidacionProformaParams
): Promise<EstaEnLiquidacionProformaResponse['value']> => {
  try {
    const res = await apiClient.post<EstaEnLiquidacionProformaResponse>(
      Endpoints.EstaEnLiquidacionProforma,
      {
        oidVisita: query.oidVisita,
      }
    );

    return res?.data?.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
